import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo Api 傳入值
 */
export interface TradingRiskScorePostBackReq {
    data: string;
}
/**
 * @todo Api 回傳值
 */
export interface TradingRiskScorePostBackResp extends GeneralResp {}

/**
 * @todo 填寫基本資料
 */
const TradingRiskScorePostBack = (data: TradingRiskScorePostBackReq): Promise<TradingRiskScorePostBackResp> => {
    const url = RouteUrlList.API_TradingRiskScorePostBack.path;
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.true, getServiceAlert: ApiClient.paramTypeEnum.true }
    };
    return ApiClient.post(url, data, config).then((res: AxiosResponse<TradingRiskScorePostBackResp>) => {
        return res.data;
    });
};

export default TradingRiskScorePostBack;
